import {
  IconApi,
  IconBook,
  IconBrandGoogle,
  IconCalendar,
  IconChartBar,
  IconCode,
  IconDatabase,
  IconSettings,
  IconTrophy,
  IconUsers,
} from '@tabler/icons-react'

import type { DocumentationPage } from '@/pages/shared/markdown'

export type DocsType = 'documentation' | 'handbook'

export const DOC_TYPE_OPTIONS = [
  { value: 'documentation', label: 'Documentation' },
  { value: 'handbook', label: 'Handbook' },
]

export const DOC_TYPE_CONFIG: Record<
  DocsType,
  {
    apiEndpoint: string
    defaultPage: string
    searchPlaceholder: string
    title: string
  }
> = {
  documentation: {
    apiEndpoint: 'documentation',
    defaultPage: 'documentation-status-report',
    searchPlaceholder: 'Search all documentation...',
    title: 'EMMA v4 Documentation',
  },
  handbook: {
    apiEndpoint: 'handbook',
    defaultPage: 'welcome',
    searchPlaceholder: 'Search handbook...',
    title: 'EMMA Handbook',
  },
}

export const documentationPages: DocumentationPage[] = [
  { icon: IconApi, id: 'api-controllers', label: 'API Controllers' },
  { icon: IconCalendar, id: 'booking-flow', label: 'Booking Flow' },
  { icon: IconUsers, id: 'customer-service', label: 'Customer Service' },
  { icon: IconSettings, id: 'dashboard-pages', label: 'Dashboard Pages' },
  { icon: IconDatabase, id: 'database-schemas', label: 'Database Schemas' },
  { icon: IconBook, id: 'documentation-status-report', label: 'Documentation Overview' },
  { icon: IconTrophy, id: 'einstein-games', label: 'Einstein Games' },
  { icon: IconBrandGoogle, id: 'gclid-integration', label: 'GCLID Integration' },
  { icon: IconCode, id: 'integration-ids', label: 'Integration IDs' },
  { icon: IconChartBar, id: 'pricing-engine', label: 'Pricing Engine' },
  { icon: IconChartBar, id: 'reporting-system', label: 'Reporting System' },
]
